module.exports = __webpack_public_path__ + "static/img/building.7933d685.png";